
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 28.392c6.031 0 10.92-4.889 10.92-10.92 0-6.03-4.889-10.92-10.92-10.92-6.03 0-10.92 4.89-10.92 10.92 0 6.031 4.89 10.92 10.92 10.92z","fill":"#3CA1F5"}}),_c('path',{attrs:{"d":"M17.472 21.768a.203.203 0 01-.12-.036l-.636-.516a8.002 8.002 0 00-5.004-1.764.19.19 0 01-.192-.192v-3.84a.19.19 0 01.192-.192 8.002 8.002 0 005.004-1.764l.636-.516a.182.182 0 01.204-.024c.06.036.108.096.108.168v8.484a.181.181 0 01-.108.168c-.036.024-.06.024-.084.024zm-5.568-2.688a8.34 8.34 0 015.052 1.848l.336.264V13.5l-.336.264a8.416 8.416 0 01-5.052 1.848v3.468z","fill":"#fff","stroke":"#fff","stroke-width":".2","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M17.472 18.948a.19.19 0 01-.192-.192v-2.82a.19.19 0 01.192-.192c.84 0 1.512.684 1.512 1.512v.168c0 .84-.684 1.524-1.512 1.524zm.192-2.808v2.424c.54-.084.948-.564.948-1.128v-.168c0-.576-.42-1.044-.948-1.128zM9.66 15.396v3.84c0 .12.096.216.216.216h.876c.12 0 .216-.096.216-.216v-3.84a.215.215 0 00-.216-.216h-.864c-.132-.012-.228.096-.228.216zm.792 3.696h-.276a.215.215 0 01-.216-.216v-3.18c0-.12.096-.216.216-.216h.288c.12 0 .216.096.216.216v3.18a.234.234 0 01-.228.216z","fill":"#fff","stroke":"#fff","stroke-width":".2","stroke-miterlimit":"10"}}),_c('path',{attrs:{"stroke":"#fff","stroke-width":".5","stroke-linecap":"round","d":"M20.354 15L25 19.646M25 15.354L20.354 20"}})])
          )
        }
      }
    